<template>
  <div>
    <div v-if="updateExists" class="update-banner">
      Uma nova versão está disponível.
      <button @click="refreshApp">Atualizar</button>
    </div>
    <router-view />
  </div>
</template>

<script>
import { xray } from './config/pluginInit'

export default {
  name: 'App',

  data() {
    return {
      updateExists: false,
      registration: null
    }
  },

  created() {
    document.addEventListener('swUpdated', this.showUpdateUI, { once: true })
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      // Notificamos o usuário antes de recarregar a página
      if (this.updateExists) {
        window.location.reload()
      }
    })
  },

  methods: {
    showUpdateUI(e) {
      this.registration = e.detail
      this.updateExists = true
    },
    refreshApp() {
      this.updateExists = false
      // Post a message to the waiting service worker.
      if (!this.registration || !this.registration.waiting) {
        return
      }
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
  },

  mounted() {
    xray.mainIndex()
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/style.scss';

.update-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #ffc107;
  color: #000;
  padding: 10px;
  text-align: center;
  z-index: 9999;
}

.update-banner button {
  margin-left: 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
}
</style>
